import { useEffect, useState } from "react";
import img_quarter from "../../../../assets/images/quarter.png";
import { fourTypes } from "../../../../util";
import GroupHeader from "../GroupHeader";
import CircleChart from "./chart";
import "./index.css";

function normalizeTo100(arr) {
  const sum = arr.reduce((acc, num) => acc + num, 0); // 배열의 전체 합 계산
  let percentages = arr.map((num) => Math.round((num / sum) * 100)); // 백분율로 변환 후 반올림

  // 백분율 합 계산
  let total = percentages.reduce((acc, num) => acc + num, 0);

  // 합이 100이 될 때까지 조정
  // while (total !== 100) {
  //   const diff = 100 - total;
  //   // 크기를 조정할 수 있는 인덱스 찾기
  //   const index = percentages.findIndex((num) => num + diff >= 0 && num !== 0);
  //   if (index !== -1) {
  //     percentages[index] += diff; // 차이(diff)를 더하여 조정
  //     total += diff; // 합 업데이트
  //   } else {
  //     break; // 적절한 조정이 불가능하면 종료
  //   }
  // }

  return percentages;
}

function GroupCircle({ userdata, groupinfo, total, page }) {
  const [countData, setCountData] = useState([]);
  const [leftData, setLeftData] = useState([
    0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
  ]);
  const [rightData, setRightData] = useState([
    0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
  ]);

  const [leftCountData, setCountLeftData] = useState([
    0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
  ]);
  const [rightCountData, setCountRightData] = useState([
    0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
  ]);

  const [leftCount, setLeftCount] = useState();
  const [rightCount, setRightCount] = useState();

  const [leftTitle, setLeftTitle] = useState();
  const [rightTitle, setRightTitle] = useState();

  useEffect(() => {
    let count = { 분석형: 0, 관계형: 0, 도전형: 0, 안정형: 0 };
    userdata.map((user) => {
      count = {
        ...count,
        [user.mainType]: (count[user.mainType] || 0) + 1,
      };
    });
    setCountData(count);

    let targetLeft = "";
    let targetRight = "";

    if (page == 0) {
      targetLeft = "분석형";
      targetRight = "관계형";
      setLeftTitle("R | 분석형");
      setRightTitle("E | 관계형");
    } else {
      targetLeft = "도전형";
      targetRight = "안정형";
      setLeftTitle("A | 도전형");
      setRightTitle("L | 안정형");
    }

    let leftDataBefore = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    let rightDataBefore = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    let leftCountDataBefore = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    let rightCountDataBefore = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    let leftCountBefore = 0;
    let rightCountBefore = 0;

    userdata.map((user) => {
      let idx = -1;
      if (user.subType == "비전가") idx = 0;
      else if (user.subType == "발명가") idx = 1;
      else if (user.subType == "모험가") idx = 2;
      else if (user.subType == "분석가") idx = 3;
      else if (user.subType == "전략가") idx = 4;
      else if (user.subType == "비평가") idx = 5;
      else if (user.subType == "설계자") idx = 6;
      else if (user.subType == "학자") idx = 7;
      else if (user.subType == "수호자") idx = 8;
      else if (user.subType == "촉진자") idx = 9;
      else if (user.subType == "상담가") idx = 10;
      else if (user.subType == "중재자") idx = 11;

      if (user.mainType == targetLeft) {
        leftDataBefore[idx]++;
        leftCountDataBefore[idx]++;
        leftCountBefore++;
      } else if (user.mainType == targetRight) {
        rightDataBefore[idx]++;
        rightCountDataBefore[idx]++;
        rightCountBefore++;
      }
    });
    setCountLeftData(leftCountDataBefore);
    setCountRightData(rightCountDataBefore);
    leftDataBefore = normalizeTo100(leftDataBefore);
    rightDataBefore = normalizeTo100(rightDataBefore);

    console.log("left count data", leftCountDataBefore);
    console.log("right count data", rightCountDataBefore);

    setLeftData(leftDataBefore);
    setRightData(rightDataBefore);
    setLeftCount(leftCountBefore);
    setRightCount(rightCountBefore);
  }, [userdata]);

  const getTypeColor = (type) => {
    if (type === "분석형") return "red";
    else if (type === "관계형") return "skyblue";
    else if (type === "도전형") return "orange";
    else if (type === "안정형") return "darkgreen";
    else return "gray";
  };

  return (
    <div className="GroupCircle page">
      <GroupHeader groupinfo={groupinfo} total={total} />

      {/* <h1 style={{ marginLeft: "1.5rem" }}>웅맹먕</h1> */}
      <div style={{ height: "50px" }}></div>
      <div className="quarter-container">
        <CircleChart
          chartData={leftData}
          chartCountData={leftCountData}
          group={groupinfo.groupname}
          count={leftCount}
          titleText={leftTitle}
        />
        <CircleChart
          chartData={rightData}
          chartCountData={rightCountData}
          group={groupinfo.groupname}
          count={rightCount}
          titleText={rightTitle}
        />
      </div>
    </div>
  );
}

export default GroupCircle;
